// Languages we offer for mock interviews — the intersection of:
//   * ElevenLabs Flash v2.5 (32 supported languages)
//   * Speechmatics real-time API (see lib/speechmaticsLanguages.ts)
//
// Every code listed below is verified to exist in SPEECHMATICS_LANGUAGES.
// Filtering through SPEECHMATICS_LANGUAGES at module load enforces the
// intersection — if either list ever drops a language, the dropdown
// silently shrinks instead of going stale.

import { SPEECHMATICS_LANGUAGES } from "@/lib/speechmaticsLanguages"

// ElevenLabs Flash v2.5 official language list (32 entries) mapped to
// Speechmatics codes. The two providers occasionally disagree on coding
// conventions — here we use Speechmatics codes since those are what we
// hand to `/api/speechmatics/realtime-key`. ElevenLabs auto-detects
// language from input text, so it doesn't need a separate code.
const ELEVENLABS_FLASH_V25_SPEECHMATICS_CODES = new Set<string>([
  "en",
  "ja",
  "cmn",
  "de",
  "hi",
  "fr",
  "ko",
  "pt",
  "it",
  "es",
  "id",
  "nl",
  "tr",
  "tl",
  "pl",
  "sv",
  "bg",
  "ro",
  "ar",
  "cs",
  "el",
  "fi",
  "hr",
  "ms",
  "sk",
  "da",
  "ta",
  "uk",
  "ru",
  "hu",
  "no",
  "vi",
])

export const MOCK_INTERVIEW_LANGUAGES = SPEECHMATICS_LANGUAGES.filter((l) =>
  ELEVENLABS_FLASH_V25_SPEECHMATICS_CODES.has(l.code)
)

export const DEFAULT_MOCK_INTERVIEW_LANGUAGE = "en"

export function isSupportedMockInterviewLanguage(code: string): boolean {
  return MOCK_INTERVIEW_LANGUAGES.some((l) => l.code === code)
}

export function getMockInterviewLanguageLabel(code: string): string {
  return MOCK_INTERVIEW_LANGUAGES.find((l) => l.code === code)?.label ?? code
}
